import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import ODataTableContext from './ODataTableContext';

class Column extends Component {
  static contextType = ODataTableContext;

  static type = 'ODataTableColumn';

  static _componentType = 'Column';

  ordina = () => {
    const { propertyName } = this.props;
    if (propertyName === '') return;
    const { sortProperty, sortDirection, sortCallback } = this.context;
    const direzione = sortProperty === propertyName ? !sortDirection : true;
    sortCallback(propertyName, direzione);
  };

  render() {
    const {
      children,
      className,
      filter,
      propertyName,
      width,
      ...others
    } = this.props;
    const {
      sortDirection,
      sortProperty,
    } = this.context;
    const style = width ? { width } : undefined;

    const columnClasses = cns(
      {
        'column--sortable': propertyName,
      },
      className,
    );
    const caretClasses = cns(
      'table__caret',
      {
        'table__caret--up': sortDirection,
      },
    );

    return (
      <th
        onClick={this.ordina}
        className={columnClasses}
        style={style}
        {...others}
      >
        {children}
        {sortProperty === propertyName
          && propertyName != null
          && (
            <span className={caretClasses} />
          )}
      </th>
    );
  }
}

Column.defaultProps = {
  children: null,
  filter: null,
  propertyName: '',
  className: '',
  width: null,
};

Column.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   * Descrive il filtro da applicare per il campo della colonna.
   * Per maggiori dettagli consultare la scheda del
   * componente **Filter**.
   */
  filter: PropTypes.shape({
    propertyName: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
    query: PropTypes.number,
    component: PropTypes.number,
    options: PropTypes.array,
    autoFocus: PropTypes.bool,
    range: PropTypes.object,
    url: PropTypes.string,
    renderProperty: PropTypes.string,
    width: PropTypes.string,
    right: PropTypes.bool,
  }),
  /** Proprietà gestita dalla colonna */
  propertyName: PropTypes.string,
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,

  /** Larghezza della colonna (es. 125px). Se non definito, la colonna occuperà lo spazio libero  */
  width: PropTypes.string,
};

export default Column;
